import * as React from "react";
type IFormDisplaySize = "tiny" | "medium" | "big";

export interface IFormDisplayContainer {
    size?: IFormDisplaySize;
    children: any;
}

class FormDisplayContainer extends React.Component<IFormDisplayContainer> {
    public render() {
        const { children } = this.props;
        const className = this.getSize();
        return (
            <div className={className}>
                {children}
            </div>
        );
    }

    private getSize = () => {
        const { size } = this.props;
        const className = `ui form ${size}`;
        return className;
    };
}

export default FormDisplayContainer;
